module.exports = __webpack_public_path__ + "img/icon-download.1a8e6d50.svg";